import { doc, setDoc } from 'firebase/firestore';
import { db, upsertUsersRootProfile } from './firebase';

export async function createApprovedStudentDoc({
  schoolId,
  classId,
  student,
  studentData,
  studentId // 학번(문서 id 아님)
}: {
  schoolId: string;
  classId: string;
  student: { uid: string };
  studentData: any;
  studentId: string;
}) {
  await setDoc(
    doc(db, `schools/${schoolId}/classes/${classId}/students/${student.uid}`),
    {
      ...studentData,
      classId,
      approvalStatus: 'approved',
      isActive: true,
      studentId // 학번은 필드로만 저장
    }
  );

  const email = (studentData.email as string | undefined) || '';
  const name = (studentData.name as string | undefined) || '';
  const lt = (studentData.loginType as string | undefined) || 'local';
  await upsertUsersRootProfile({
    uid: student.uid,
    email,
    name,
    role: 'student',
    schoolId,
    loginType: lt === 'password' || lt === 'email' ? 'local' : lt,
    isActive: true,
  });
} 